exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ButtonResumeTs_btn__lA4uu{padding:5px 10px;border-radius:21px;font-size:14px;line-height:20px;border:none;background:#3dcd58;color:#fff}.ButtonResumeTs_btn__lA4uu:active,.ButtonResumeTs_btn__lA4uu:focus{outline:0}", ""]);

// exports
exports.locals = {
	"btn": "ButtonResumeTs_btn__lA4uu"
};